import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { FaClipboardList, FaCalendarAlt } from "react-icons/fa";
import config from "../../config/config";
import { getAuthToken } from "../../utils/token";
import Loader from "../loader/Loader";

const LatestDispatchPlan = () => {
    const [loading, setLoading] = useState(false);
    const [dispatchPlan, setDispatchPlan] = useState(null);

    useEffect(() => {
        fetchLatestDispatchPlan();
    }, []);

    const fetchLatestDispatchPlan = async () => {
        const token = getAuthToken();

        if (!token) {
            toast.error("Authentication token not found.");
            return;
        }

        try {
            setLoading(true);

            const response = await axios.get(
                `${config.API}/senmanager/latestDispatchPlan`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.data?.success) {
                setDispatchPlan(response.data?.record || null);
            } else {
                setDispatchPlan(null);
                toast.warning(
                    response.data?.message ||
                    "No dispatch plan found."
                );
            }
        } catch (error) {
            console.error(
                "Latest Dispatch Plan Error:",
                error
            );

            setDispatchPlan(null);

            toast.error(
                error.response?.data?.message ||
                "Failed to load dispatch plan."
            );
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (date) => {
        if (!date) return "-";

        return new Date(date).toLocaleString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    };

    return (
        <div className="container-fluid px-0 py-1">
            {loading ? (
                <div className="py-1">
                    <Loader />
                </div>
            ) : dispatchPlan ? (
                <div
                    className="d-flex align-items-center justify-content-between border rounded-3 bg-white shadow-sm px-3 py-2"
                    style={{ minHeight: "48px" }}
                >
                    {/* Left */}
                    <div className="d-flex align-items-center gap-2">
                        <div
                            className="rounded-circle bg-primary bg-opacity-10 text-primary d-flex align-items-center justify-content-center"
                            style={{
                                width: "30px",
                                height: "30px",
                            }}
                        >
                            <FaClipboardList size={14} />
                        </div>

                        <div className="fw-semibold small">
                            Latest Updated Plan
                        </div>
                    </div>

                    {/* Center */}
                    <div className="d-flex align-items-center gap-2 text-muted small">
                        <FaCalendarAlt
                            className="text-primary"
                            size={13}
                        />

                        <span>
                            Created On -:
                            {formatDate(
                                dispatchPlan.created_at
                            )}
                        </span>
                    </div>
                    <div className="d-flex align-items-center gap-2 text-muted small">
                        <FaCalendarAlt
                            className="text-primary"
                            size={13}
                        />

                        <span>
                            Updated On -:
                            {formatDate(
                                dispatchPlan.updated_at
                            )}
                        </span>
                    </div>
                    {/* Right */}
                    <span className="badge bg-success-subtle text-success px-2 py-1">
                        Active
                    </span>
                </div>
            ) : (
                <div className="border rounded-3 bg-light text-muted text-center py-2 small">
                    No latest dispatch plan available
                </div>
            )}
        </div>
    );
};

export default LatestDispatchPlan;